import { z } from 'zod';

/* ─────────── Переговорные компании (ЗД-14) ─────────── */

export const MeetingRoom = z.object({
  id: z.uuid(),
  name: z.string(),
  /** Офис, этаж или адрес текстом */
  location: z.string().nullable(),
  /** Комната на площадке проекта */
  projectId: z.uuid().nullable(),
  projectCode: z.string().nullable(),
  objectId: z.uuid().nullable(),
  objectName: z.string().nullable(),
  capacity: z.number().int().nullable(),
  hasScreen: z.boolean(),
  hasVideo: z.boolean(),
  hasBoard: z.boolean(),
  /** Постоянная ссылка на видеосвязь комнаты (ЗД-08) */
  videoUrl: z.string().nullable(),
  note: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.string(),
});
export type MeetingRoom = z.infer<typeof MeetingRoom>;

const optText = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .nullable()
    .optional()
    .transform((v) => (v ? v : null));

export const MeetingRoomInput = z.object({
  name: z.string().trim().min(1, 'Укажите название').max(200),
  location: optText(300),
  projectId: z.uuid().nullable().optional(),
  objectId: z.uuid().nullable().optional(),
  capacity: z.number().int().min(1, 'Не меньше 1').max(1000, 'Не больше 1000').nullable().optional(),
  hasScreen: z.boolean().optional(),
  hasVideo: z.boolean().optional(),
  hasBoard: z.boolean().optional(),
  videoUrl: z
    .string()
    .trim()
    .max(500)
    .refine((v) => v === '' || /^https:\/\/\S+$/i.test(v), 'Ссылка должна начинаться с https://')
    .nullable()
    .optional()
    .transform((v) => (v ? v : null)),
  note: optText(1000),
  isActive: z.boolean().optional(),
});
export type MeetingRoomInput = z.input<typeof MeetingRoomInput>;

/** Правка карточки целиком: все поля обязательны, чтобы неполное тело не стёрло оборудование и место комнаты */
export const MeetingRoomUpdate = MeetingRoomInput.required();
export type MeetingRoomUpdate = z.input<typeof MeetingRoomUpdate>;

export const MeetingRoomQuery = z.object({
  /** Показать и архивные комнаты — только для тех, кто ведёт справочник */
  all: z.enum(['1']).optional(),
});
